module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BG-70141cab622287500e5b513fc6ad4b13.png";